module.exports = __webpack_public_path__ + "@/assets/img/dashboard-due-alert2.a92be5f5.png";